import { BRAND_ASSETS } from "@/lib/brandAssets";

export const SITE_URL = "https://junkindatruck.com";
export const DEFAULT_OG_IMAGE = BRAND_ASSETS.social;

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}#business`,
  name: "Junk In Da Truck",
  alternateName: "Junk In Da Truck Junk Removal",
  url: SITE_URL,
  telephone: "+17724945048",
  email: "info@junkindatruck.com",
  image: DEFAULT_OG_IMAGE,
  logo: DEFAULT_OG_IMAGE,
  priceRange: "$$",
  paymentAccepted: "Cash, Credit Card, Zelle",
  currenciesAccepted: "USD",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Vero Beach",
    addressRegion: "FL",
    postalCode: "32960",
    addressCountry: "US"
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 27.6393,
    longitude: -80.3970
  },
  areaServed: [
    "Vero Beach, FL",
    "Sebastian, FL",
    "Melbourne, FL",
    "Palm Bay, FL",
    "Port St. Lucie, FL",
    "Fort Pierce, FL",
    "Stuart, FL",
    "Indian River County, FL",
    "Brevard County, FL",
    "St. Lucie County, FL",
    "Martin County, FL"
  ],
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], opens: "07:00", closes: "19:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Sunday", description: "By Appointment" }
  ],
  sameAs: [
    "https://www.facebook.com/JunkInDaTruck/",
    "https://instagram.com/junkindatruck",
    "https://x.com/JunkInDaTruck"
  ]
};

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Junk In Da Truck",
    url: SITE_URL,
  };
}

export function faqSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}
